import { TimelineMax, TweenMax, Expo } from 'gsap';

const hoverProject = (el, width) => {
  const tl = new TimelineMax({ paused: true });

  const line = el.querySelector('.list__line:not(.list__line--first)');
  const lineHover = el.querySelector('.list__line--hover');
  const discover = el.querySelector('.discover');

  tl.addLabel('start')
    .to(line, 0.8, {
      width,
      ease: Expo.easeInOut,
    }, 'start')
    .to(lineHover, 1.2, {
      scaleX: 1,
      ease: Expo.easeInOut,
    }, 'start')
    .to(discover, 0.8, {
      autoAlpha: 1,
      yPercent: -50,
      ease: Expo.easeInOut,
    }, 'start+=0.2')

  return tl;
};

export default hoverProject;
